<template>
  <div>
    <!-- <div class="d-flex justify-content-end">
      <select-all
        @select-all="selectAll"
        @un-select-all="unSelectAll"
        :all="all"
      />
    </div> -->
    <div
      v-for="item in props"
      :key="item.id"
      class="d-flex justify-content-between mb-4"
    >
      <app-media-object
        :img-url="item.avatar"
        :media-title="item.title"
        :media-subtitle="item.subtitle"
      />
      <!-- <app-input type="checkbox" :list="[{ id: item.id }]" v-model="selected" /> -->
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import SelectAll from "./SelectAll";

export default {
  name: "ReviewList",
  mixins: [FormMixin],
  components: { SelectAll },
  props: {
    props: { default: () => [] },
  },
  data() {
    return {
      selected: [],
      all: false,
    };
  },
  watch: {
    selected(val) {
      if (val.length === this.props.length) this.all = ["-1"];
      else this.all = [];
    },
  },
  methods: {
    selectAll() {
      this.selected = this.props.map((item) => item.id);
    },
    unSelectAll() {
      this.selected = [];
    },
  },
};
</script>
